<template>
  <div class="w-full">
    <v-form
      ref="textForm"
      v-model="isFormValid"
      name="company-settings-text"
    >
      <CheckTextField
        color="primary"
        v-model="localValue"
        :loading="isLoading"
        :rules="required ? [rules.required] : []"
        outlined
        :label="label"
        :name="name"
        :disabled="disabled"
        :placeholder="placeholder"
        :suffix="suffix"
        :type="type"
        validate-on-input
        @click="onClick(name, localValue)"
      />
    </v-form>
  </div>
</template>

<script>
import CheckTextField from '@/components/forms/CheckTextField'
import { required } from '@/lib/validation'

export default {
  components: {
    CheckTextField,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    suffix: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
  },
  data() {
    return {
      localValue: this.value,
      debounceTimeout: null,
      spinnerTimeout: null,
      isLoading: false,
      isFormValid: false,
      isFieldValid: false,
    }
  },

  watch: {
    value(newValue) {
      this.localValue = newValue
    },
    localValue() {
      this.update()
    },
  },

  created() {
    this.rules = { required }
  },

  unmounted() {
    clearTimeout(this.spinnerTimeout)
    clearTimeout(this.debounceTimeout)
  },

  methods: {
    onClick(label, value) {
      this.$tracking.event('Settings', 'Clicked', label, value)
    },
    async update() {
      clearTimeout(this.debounceTimeout)
      this.debounceTimeout = setTimeout(() => {
        this.isLoading = true
        this.spinnerTimeout = setTimeout(async () => {
          const { valid } = await this.$refs.textForm.validate()
          if (valid) {
            this.$emit('update', { name: this.name, value: this.localValue })
            this.$tracking.event('Settings', 'Edited', this.name, this.localValue)
          }
          this.isLoading = false
        }, 1000)
      }, 2000)
    },
  },
  emits: ['update'],
}
</script>
